import { Row } from 'react-table';

import { isInDateRange } from '@trqk/utils';

/**
 * Filters table rows by date range. Each row must have a single `date` in its original data, which
 * must be a Date instance. This will not filter rows according to whether the row date range is
 * within a filter date range; i.e. by whether a row has a child date range of a filter value. To
 * do that, you would need to set up a different filter function that uses `isChildDateRange()`.
 * @param rows {Row<D>[]}
 * @param ids
 * @param filterValue a DateRange
 */
function filterByDateRange<D extends DateItem>(
    rows: Row<D>[],
    ids: string[],
    filterValue: MaybeEmptyDateRange,
): Row<D>[] {
    if (filterValue.start === null) {
        return rows;
    }

    return rows.filter((row: Row<D>): boolean => {
        const { date } = row.original;

        return isInDateRange(date, filterValue);
    });
}
// Let the table remove the filter if the value is empty.
filterByDateRange.autoRemove = (filterValue: DateRange): boolean =>
    filterValue.start === null && filterValue.end === null;

export { filterByDateRange };
